import { IPropsWithChildren, IPropsWithClassName } from 'interfaces';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

export interface LoadingBoxProps extends IPropsWithClassName, IPropsWithChildren {
  border?: boolean;
  block?: boolean;
  bigText?: boolean;
}

const LoadingBox = ({
  border = true,
  block = true,
  bigText = false,
  className,
  children,
}: LoadingBoxProps) => {
  const componentClass = twMerge(classNames(
    'rounded-lg',
    'text-center',
    'p-7',
    'text-darkGray',
    'text-sm',
    'bg-white',
    {
      'text-sm': !bigText,
      'text-lg': bigText,
      'border border-darkGray': border,
      block,
    },
    className,
  ));

  return (
    <div className={componentClass}>
      {children}
    </div>
  );
};

export default LoadingBox;
